export class ValidTypeList {

    public static readonly FloatComma = /^-?(?=.)(\d{1,3}(,\d{3})*)?(\.\d+)?$/;  // for number 12,345,678.0045
    // commas are required
    // Can start with "."
    // Can be negative
    // Pass: 1,234,567.8912, 1234567.8912
    // Fail: 10000,000, 1,00,00.34, -234,567.00

    public static readonly PositiveFloatOptionalComma = /^(\d+|\d{1,3}(,\d{3})*)(\.\d+)?$/;
    // commas are optional as long as they're consistent
    // Can't start with "."
    // Can't be negative
    // Pass: 1,234,567.8912, 1234567.8912
    // Fail: 10000,000, 1,00,00.34, -234,567.00

}
